enum MergeDialogFields {
	FILES = "files",
	OPERATION = "operation",
	PAGE = "page",
	RESET_METADATA = "reset_metadata",
	PDFA_FORMAT = "pdfa_format",
	PDFA_RESOLUTION = "pdfa_resolution",

}

export default MergeDialogFields;